// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* > Mobile */

.what-content_fire-bottom {
  position: relative;
}
.what-content {
  width: 100%;
  margin: 200px 0 3rem 0;
  position: relative;
  padding-left: 1rem;
  padding-right: 1rem;
}

section.what-content_bottom {
  background-color: var(--secondaryColor);
  padding-left: 1rem;
  padding-top: 3rem;
}

.what-content_section {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 4rem;
}
.what-content .what-content_section h1,
h3,
p {
  color: var(--text-color-dark);
}
.subtitle-bottom {
  padding-top: 4rem;
  color: var(--text-color-light);
}

.what-subtitle {
  margin-top: 2rem;
  display: flex;
  color: var(--text-color-light);
}
.what-subtitle:hover {
  background-color: var(--light-blackBg);
  color: var(--secondaryColor);
  padding-left: 3rem;
  padding-right: 3rem;
  transition: all 0.5s ease-out;
}
.what-content_article {
  color: var(--text-color-dark);
}
.what-content_article p {
  margin-top: 1.2em;
}
.what-content_article ul li {
  margin: 1.2rem;
  cursor: pointer;
  color: var(--text-color-light);
}
.what-content_article ul li:hover {
  color: var(--primaryColor) !important;
  transition: color 1s;
  text-decoration: underline;
}
.what-content_article ul li a p {
  color: var(--text-color-light);
}
.what-content_article h5 {
  color: var(--text-color-light);
  margin-top: 1.2rem;
  text-decoration: underline;
}

.what-web-projects p {
  margin: 0;
}

/* > Tablet */
@media only screen and (min-width: 677px) {
  .what-content {
    padding-top: 0;
  }
  section.what-content_bottom {
    margin: 0;
    padding-left: 0;
  }
  .what-content_section {
    flex-direction: row;
    justify-content: space-evenly;
    align-items: baseline;
  }
  .what-content_article {
    margin-left: 2rem;
    margin-bottom: 6rem;
    width: 50%;
  }
}

.max-width-modal {
  max-width: 95vw;
}
.max-width-modal h5 {
  padding-left: 2rem;
}

/* > Big Desktop */
@media only screen and (min-width: 1024px) {
  .what-content {
    padding-top: 2rem;
  }
  .what-content_article {
    font-size: 1.5em;
    max-width: 100%;
    letter-spacing: 2px;
    line-height: 1.6em;
  }
  section.what-content_bottom {
    margin: 0;
    padding-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/whatandwithwho.css"],"names":[],"mappings":"AAAA,aAAa;;AAEb;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;AACA;;;EAGE,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,sCAAsC;EACtC,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,0BAA0B;AAC5B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;AACX;;AAEA,aAAa;AACb;EACE;IACE,cAAc;EAChB;EACA;IACE,SAAS;IACT,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,6BAA6B;IAC7B,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,SAAS;IACT,eAAe;EACjB;AACF","sourcesContent":["/* > Mobile */\n\n.what-content_fire-bottom {\n  position: relative;\n}\n.what-content {\n  width: 100%;\n  margin: 200px 0 3rem 0;\n  position: relative;\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\nsection.what-content_bottom {\n  background-color: var(--secondaryColor);\n  padding-left: 1rem;\n  padding-top: 3rem;\n}\n\n.what-content_section {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 4rem;\n}\n.what-content .what-content_section h1,\nh3,\np {\n  color: var(--text-color-dark);\n}\n.subtitle-bottom {\n  padding-top: 4rem;\n  color: var(--text-color-light);\n}\n\n.what-subtitle {\n  margin-top: 2rem;\n  display: flex;\n  color: var(--text-color-light);\n}\n.what-subtitle:hover {\n  background-color: var(--light-blackBg);\n  color: var(--secondaryColor);\n  padding-left: 3rem;\n  padding-right: 3rem;\n  transition: all 0.5s ease-out;\n}\n.what-content_article {\n  color: var(--text-color-dark);\n}\n.what-content_article p {\n  margin-top: 1.2em;\n}\n.what-content_article ul li {\n  margin: 1.2rem;\n  cursor: pointer;\n  color: var(--text-color-light);\n}\n.what-content_article ul li:hover {\n  color: var(--primaryColor) !important;\n  transition: color 1s;\n  text-decoration: underline;\n}\n.what-content_article ul li a p {\n  color: var(--text-color-light);\n}\n.what-content_article h5 {\n  color: var(--text-color-light);\n  margin-top: 1.2rem;\n  text-decoration: underline;\n}\n\n.what-web-projects p {\n  margin: 0;\n}\n\n/* > Tablet */\n@media only screen and (min-width: 677px) {\n  .what-content {\n    padding-top: 0;\n  }\n  section.what-content_bottom {\n    margin: 0;\n    padding-left: 0;\n  }\n  .what-content_section {\n    flex-direction: row;\n    justify-content: space-evenly;\n    align-items: baseline;\n  }\n  .what-content_article {\n    margin-left: 2rem;\n    margin-bottom: 6rem;\n    width: 50%;\n  }\n}\n\n.max-width-modal {\n  max-width: 95vw;\n}\n.max-width-modal h5 {\n  padding-left: 2rem;\n}\n\n/* > Big Desktop */\n@media only screen and (min-width: 1024px) {\n  .what-content {\n    padding-top: 2rem;\n  }\n  .what-content_article {\n    font-size: 1.5em;\n    max-width: 100%;\n    letter-spacing: 2px;\n    line-height: 1.6em;\n  }\n  section.what-content_bottom {\n    margin: 0;\n    padding-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
